<div class="col-lg-8 col-md-7 col-sm-12">
  <table class="manage-table responsive-table">
    <div class="style-2">
      <ul class="tabs-nav">
        <li class="active" (click)="getActivePropertyMethod()">
          <a href="#ActiveProperty" id="active">Active</a>
        </li>
        <li (click)="getPendingPropertyMethod()">
          <a id="pending" href="#PendingProperty">Pending</a>
        </li>
        <li (click)="getRejectedPropertyMethod()">
          <a id="rejected" href="#RejectedProperty">Rejected</a>
        </li>
        <li (click)="getSoldPropertyMethod()">
          <a id="sold" href="#SoldProperty">Sold</a>
        </li>
      </ul>
      <div class="tabs-container">
        <div class="tab-content" id="ActiveProperty">
          @if (ActiveCollection.data.length == 0 && activeProcessed) {
            <div class="row margin-top-100 margin-bottom-100"
              >
              <div class="col-sm-12 text-center">
                <h3>Oops!</h3>
                <p>
                  You don't have any active property right now.
                </p>
              </div>
            </div>
          }
          @for (property of ActiveCollection.data; track property) {
            <div class="margin-bottom-10">
              <div class="title-container">
                <img src="{{property.Image}}" alt="">
                <div class="title">
                  <h4>
                    <a [routerLink]="['/property',property.PropertyUrl]" queryParamsHandling="preserve"
                    style="cursor: pointer;">{{property.Title}}</a>
                  </h4>
                  <span class="desc-span-height">{{property.Description}} </span>
                  <span class="table-property-price">PKR {{property.PriceInWords}}</span>&nbsp;
                  <span class="table-property-price">{{property.CreateDate}}</span>&nbsp;
                  <span class="table-property-price">
                    <a href="javascript:void(0)" (click)="markSoldProperty(property);">
                      <i class="sl sl-icon-energy"></i> Sold
                    </a>
                  </span>&nbsp;
                  <span class="table-property-price">
                    <a [routerLink]="['/property/forms/submit', property.PropertyId]">
                      <i class="fa fa-pencil"></i> Edit
                    </a>
                  </span>&nbsp;
                  <span class="table-property-price"> <a href="javascript:void(0)" class="delete" [swal]="deleteSwal"><i
                  class="fa fa-remove"></i>
                Delete</a>
                <swal #deleteSwal title="Delete" text="Are you sure you want to delete this property?" icon="question"
                  [showCancelButton]="true" [focusCancel]="true" (confirm)="DeleteEvent(property,'active')">
                </swal>
              </span>
            </div>
          </div>
          <hr>
          </div>
        }
      </div>
      <div class="tab-content" id="PendingProperty">
        @if (PendingCollection.data.length == 0 && pendingProcessed) {
          <div class="row margin-top-100 margin-bottom-100"
            >
            <div class="col-sm-12 text-center">
              <h3>Hooray!</h3>
              <p>
                You don't have any pending property right now.
              </p>
            </div>
          </div>
        }
        @for (property of PendingCollection.data; track property) {
          <div class="margin-bottom-10">
            <div class="title-container">
              <img src="{{property.Image}}" alt="">
              <div class="title">
                <h4>
                  <a href="javascript:void(0);" queryParamsHandling="preserve"
                  style="cursor: pointer;">{{property.Title}}</a>
                </h4>
                <span class="desc-span-height">{{property.Description}} </span>
                <span class="table-property-price">PKR {{property.PriceInWords}}</span>&nbsp;
                <span class="table-property-price">{{property.CreateDate}}</span>&nbsp;
                <span class="table-property-price">
                  <a [routerLink]="['/property/forms/submit', property.PropertyId]">
                    <i class="fa fa-pencil"></i> Edit
                  </a>
                </span>&nbsp;
                <span class="table-property-price"> <a href="javascript:void(0)" class="delete" [swal]="deleteSwal"><i
                class="fa fa-remove"></i>
              Delete</a>
              <swal #deleteSwal title="Delete" text="Are you sure you want to delete this property?" icon="question"
                [showCancelButton]="true" [focusCancel]="true" (confirm)="DeleteEvent(property,'pending')">
              </swal>
            </span>
          </div>
        </div>
        <hr>
        </div>
      }
    </div>
    <div class="tab-content" id="RejectedProperty">
      @if (RejectedCollection.data.length == 0 && rejectedProcessed) {
        <div class="row margin-top-100 margin-bottom-100"
          >
          <div class="col-sm-12 text-center">
            <h3>Hooray!</h3>
            <p>
              We are happy for you, as you don't have any rejected property right now.
            </p>
          </div>
        </div>
      }
      @for (property of RejectedCollection.data; track property) {
        <div class="margin-bottom-10">
          <div class="title-container">
            <img src="{{property.Image}}" alt="">
            <div class="title">
              <h4>
                <a href="javascript:void(0);" queryParamsHandling="preserve"
                style="cursor: pointer;">{{property.Title}}</a>
              </h4>
              <span class="desc-span-height">{{property.Description}} </span>
              <span class="table-property-price">PKR {{property.PriceInWords}}</span>&nbsp;
              <span class="table-property-price">{{property.CreateDate}}</span>&nbsp;
              <span class="table-property-price">
                <a [routerLink]="['/property/forms/submit', property.PropertyId]">
                  <i class="fa fa-pencil"></i> Edit
                </a>
              </span>&nbsp;
              <span class="table-property-price"> <a href="javascript:void(0)" class="delete" [swal]="deleteSwal"><i
              class="fa fa-remove"></i>
            Delete</a>
            <swal #deleteSwal title="Delete" text="Are you sure you want to delete this property?" icon="question"
              [showCancelButton]="true" [focusCancel]="true" (confirm)="DeleteEvent(property,'rejected')">
            </swal>
          </span>
        </div>
      </div>
      <hr>
      </div>
    }
  </div>
  <div class="tab-content" id="SoldProperty">
    @if (SoldCollection.data.length == 0 && soldProcessed) {
      <div class="row margin-top-100 margin-bottom-100">
        <div class="col-sm-12 text-center">
          <h3>Oops!</h3>
          <p>
            You didn't sold any property yet.
          </p>
        </div>
      </div>
    }
    @for (property of SoldCollection.data; track property) {
      <div class="margin-bottom-10">
        <div class="title-container">
          <img src="{{property.Image}}" alt="">
          <div class="title">
            <h4>
              <a [routerLink]="['/property',property.PropertyUrl]" queryParamsHandling="preserve"
              style="cursor: pointer;">{{property.Title}}</a>
            </h4>
            <span class="desc-span-height">{{property.Description}} </span>
            <span class="table-property-price">PKR {{property.PriceInWords}}</span>&nbsp;
            <span class="table-property-price">{{property.CreateDate}}</span>&nbsp;
          </div>
        </div>
        <hr>
        </div>
      }
    </div>
  </div>
</div>
</table>
</div>

<!-- <div *ngIf="IsLoading" class="customLoader"></div> -->
@if (IsLoading) {
  <div class="spinnerPlacement">
    <app-spinner></app-spinner>
  </div>
}
